// Phase 8c — shared pieces used across all rate admin schemas.
//
// Money: STRING-typed decimal (prevents JSON precision loss; matches
//   the engine's snapshot contract from 8b).
// IsoDate: 'YYYY-MM-DD' for effective_from / effective_to (column type
//   @db.Date in Prisma).
// Reason: every mutation request carries a reason field (operator must
//   document why) — feeds into rate_change_log.
// LeadTimeOverride: 14-day lead time is enforced server-side (8B + 8c-3
//   lock). Operator can override by supplying { overrideLeadTime: true,
//   overrideReason: string >= 10 chars }; both persist in the audit +
//   change-log.
import { z } from 'zod';
export const RateMoneyAmountSchema = z
    .string()
    .regex(/^\d+(\.\d{1,4})?$/, 'Money amount must be a positive decimal with up to 4 dp');
export const RateIsoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD');
export const RateReasonSchema = z
    .string()
    .min(10, 'Reason must be at least 10 characters — document why')
    .max(500);
export const RateLeadTimeOverrideSchema = z
    .object({
    overrideLeadTime: z.boolean().optional(),
    overrideReason: z.string().min(10).max(500).optional(),
})
    .refine((v) => !v.overrideLeadTime || (v.overrideReason !== undefined && v.overrideReason.length >= 10), { message: 'overrideReason is required (>=10 chars) when overrideLeadTime is true' });
//# sourceMappingURL=_shared.schema.js.map